import type {
  ChangePasswordRequestDto,
  CurrentUserDto,
  UpdateMeRequestDto,
} from '@/types/auth/auth.types'
import type { CurrentUser } from '@/types/auth/current-user'

export interface ProfileNameInput {
  firstName: string
  lastName: string
}

export interface ChangePasswordInput {
  currentPassword: string
  newPassword: string
  confirmation: string
}

export function toCurrentUser(dto: CurrentUserDto): CurrentUser {
  return {
    id: dto.id,
    firstName: dto.first_name,
    lastName: dto.last_name,
    email: dto.email,
    role: dto.role,
    status: dto.status,
    permissions: dto.permissions,
  }
}

export function profileNameChanges(
  input: ProfileNameInput,
  current: ProfileNameInput,
): Partial<ProfileNameInput> {
  const changes: Partial<ProfileNameInput> = {}
  const firstName = input.firstName.trim()
  const lastName = input.lastName.trim()
  if (firstName !== current.firstName) changes.firstName = firstName
  if (lastName !== current.lastName) changes.lastName = lastName
  return changes
}

/** The changes Save may send: none while a name is blank, which the API rejects. */
export function profileNameUpdate(
  input: ProfileNameInput,
  current: ProfileNameInput,
): Partial<ProfileNameInput> {
  const blank = input.firstName.trim() === '' || input.lastName.trim() === ''
  return blank ? {} : profileNameChanges(input, current)
}

export function toUpdateMePayload(
  changes: Partial<ProfileNameInput>,
): UpdateMeRequestDto {
  return {
    ...(changes.firstName !== undefined && { first_name: changes.firstName }),
    ...(changes.lastName !== undefined && { last_name: changes.lastName }),
  }
}

/** Sent verbatim — the backend never trims a password, so neither may the client. */
export function toChangePasswordPayload(
  input: ChangePasswordInput,
): ChangePasswordRequestDto {
  return {
    current_password: input.currentPassword,
    new_password: input.newPassword,
    confirmation: input.confirmation,
  }
}
